module.exports = __webpack_public_path__ + "img/mouth-05.1eff4e34.svg";